import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(pages)/layout.tsx");
